export const SET_LANGUAGE = 'SET_LANGUAGE';

export interface LangState {
    language:number
}
export interface LangAction{
    type: typeof SET_LANGUAGE,
    payload:number
}